if (typeof Mapa !== " function") {
  window.Mapa = function (wrapper, duracion, arreglo, pais) {
    let data = null;
    let mapa = null;

    let svg = null;
    let gEstados = null;
    let gMunicipios = null;
    let gIncendios = null;

    let svgLeyenda = null;
    let gEtiquetas = null;

    let scrollerDown = null;
    let scrollerUp = null;

    let path = d3.geoPath();

    //let escalaRadio = d3.scaleSqrt().domain([1000, 2000]).range([0.8, 1.14]);
    let escalaRadio = d3
      .scaleSqrt()
      .domain([1000, 2000])
      .range([0.8 * 2, 1.14 * 2]);

    let intervalId = null;
    let fecha = null;
    let numero = null;
    let superficie = null;

    let breakpoint = 576;
    let formato = null;

    const objCoordenadas = {
      escritorio: {
        estados: { centro: [23.718, -102.73], zoom: 6 },
        municipios: { centro: [25.078, -105.659], zoom: 7.75 },
        sinaloa: { centro: [25.178, -106.659], zoom: 8.25 },
        formato: "horizontal",
      },
      movil: {
        estados: { centro: [22.718, -106.23], zoom: 5.75 },
        municipios: { centro: [23.9, -106.509], zoom: 6.8 },
        sinaloa: { centro: [24.178, -106.959], zoom: 7.2 },
        formato: "vertical",
      },
    };

    let coordenadas = null;
    let flagAnimar = true;

    function setFormato() {
      let w = document.documentElement.clientWidth;
      if (w > breakpoint) {
        formato = "horizontal";
      } else {
        formato = "vertical";
      }
      coordenadas =
        formato == "horizontal"
          ? objCoordenadas.escritorio
          : objCoordenadas.movil;
    }

    function setup() {
      setFormato();
      crearMapa();
    }

    function crearMapa() {
      mapa = L.map("mapa", {
        zoomSnap: 0.25,
        zoomControl: false,
        gestureHandling: false,
        scrollWheelZoom: false,
      }).setView(coordenadas.estados.centro, coordenadas.estados.zoom);

      //window.mapa = mapa;
      mapa.dragging.disable();
      mapa.touchZoom.disable();
      mapa.doubleClickZoom.disable();
      mapa.scrollWheelZoom.disable();
      mapa.boxZoom.disable();
      mapa.keyboard.disable();

      let URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
      URL = "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png";
      L.tileLayer(URL, {
        maxZoom: 20,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      }).addTo(mapa);

      let box = wrapper.node().getBoundingClientRect();
      let bounds = mapa.getBounds();

      svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("viewBox", `0 0 ${box.width} ${box.height}`);
      L.svgOverlay(svg, bounds).addTo(mapa);

      svg = d3.select(svg);

      gEstados = svg
        .append("g")
        .style("fill", "#b3b3b3ff")
        .style("stroke", "#ffffff")
        .style("stroke", "#000000")
        .style("stroke-width", 3)
        .style("opacity", 0.3)
        .attr("id", "gEstados");
      gMunicipios = svg
        .append("g")
        .style("fill", "#79ec8cff")
        .style("stroke", "#79ec8cff")
        .style("opacity", 0.3)
        .attr("id", "gMunicipios");
      gIncendios = svg.append("g").attr("id", "gIncendios");

      if (formato == "horizontal") {
        let rect = null;
        svgLeyenda = d3.select(mapa.getPanes().overlayPane).append("svg");
        svgLeyenda.attr("preserveAspectRatio", "xMidYMid");
        svgLeyenda.attr("viewBox", `0 0 ${box.width} ${box.height}`);
        svgLeyenda.style("width", `${box.width}px`);
        svgLeyenda.style("height", `${box.height}px`);
        svgLeyenda.style("transform", "translate3d(0px, 0px, 0px)");

        svgLeyenda = svgLeyenda
          .append("g")
          .attr("transform", `translate(20, ${box.height - 320})`);
        rect = svgLeyenda
          .append("rect")
          .attr("x", 0)
          .attr("y", 0)
          .attr("fill", "transparent");

        gEtiquetas = svgLeyenda.append("g").attr("data-g", "gEtiquetas");
        let claves = [25000, 50000, 100000];
        let offsetY = 0;
        let grupos = gEtiquetas
          .selectAll("g.etiqueta")
          .data(claves)
          .enter()
          .append("g")
          .attr("transform", function (d, i) {
            offsetY += i > 0 ? 2 * escalaRadio(claves[i - 1]) + 10 : 0;
            return `translate(25, ${offsetY})`;
          });

        grupos
          .append("circle")
          .style("fill", "#ff993aff") //FD9A01
          .style("stroke", "rgba(185, 100, 20, 1)")
          .style("stroke-width", "0.5px")
          .style("opacity", 0.7)
          .attr("cx", 0)
          .attr("cy", (d) => escalaRadio(d))
          .attr("r", (d) => escalaRadio(d));

        let mayor = claves[claves.length - 1];
        let formatoSuperficie = d3.format(",.0f");
        grupos
          .append("text")
          .attr("fill", "#ffffff")
          .attr("x", 130)
          .attr("y", (d) => escalaRadio(d) + 2)
          .text((d) => `${formatoSuperficie(d)} hectáreas`)
          .attr("dominant-baseline", "middle")
          .attr("text-anchor", "end");

        let caja = gEtiquetas.node().getBBox();
        rect
          .attr("x", caja.x)
          .attr("width", caja.width)
          .attr("height", caja.height);
      }
      procesaData();
    }

    function procesaData() {
      data = _.filter(arreglo, function (d) {
        return d.coord[0] != 0 && d.coord[1] != 0;
      });

      _.each(data, function (d) {
        d.punto = calculaCentro(d.coord);
      });

      let estados = topojson.feature(pais, pais.objects.estados);
      estados = estados.features;

      let municipios = topojson.feature(pais, pais.objects.municipiosinteres);
      municipios = municipios.features;

      let transform = d3.geoTransform({ point: proyectarPunto });
      path.projection(transform);

      setEstados(estados);
      setMunicipios(municipios);

      crearScrollers();

      d3.select("#play").on("click", function (e) {
        e.preventDefault();
        if (_.isNull(intervalId)) {
          mapa.flyTo(
            coordenadas.municipios.centro,
            coordenadas.municipios.zoom
          );
          animaIncendios();
        }
      });
      d3.select("#stop").on("click", function (e) {
        e.preventDefault();
        detenIncendios();
      });

      fecha = d3.select("#fecha");
      numero = d3.select("#numero");
      superficie = d3.select("#superficie");
    }

    function proyectarPunto(x, y) {
      let point = mapa.latLngToLayerPoint(new L.LatLng(y, x));
      this.stream.point(point.x, point.y);
    }

    function setEstados(estados) {
      gEstados
        .selectAll("path")
        .data(estados)
        .enter()
        .append("path")
        .attr("d", path);
    }

    let cajaMunicipios = null;
    let cajaSinaloa = null;
    function setMunicipios(municipios) {
      gMunicipios
        .style("opacity", 0)
        .selectAll("path")
        .data(municipios)
        .enter()
        .append("path")
        .attr("d", path);

      console.log(municipios);
      let geoJsonLayer = L.geoJson(municipios);
      geoJsonLayer.addTo(mapa); // Add the layer to the map if desired
      cajaMunicipios = geoJsonLayer.getBounds();
      mapa.removeLayer(geoJsonLayer);
      console.log(cajaMunicipios);
      console.log("Layer Bounding Box String:", cajaMunicipios.toBBoxString());

      let sinaloa = _.filter(municipios, function (d) {
        return d.properties.CVE_ENT == "25";
      });
      geoJsonLayer = L.geoJson(sinaloa);
      geoJsonLayer.addTo(mapa); // Add the layer to the map if desired
      cajaSinaloa = geoJsonLayer.getBounds();
      mapa.removeLayer(geoJsonLayer);
      console.log(cajaSinaloa);
      console.log("Layer Bounding Box String:", cajaSinaloa.toBBoxString());
    }

    function crearScrollers() {
      let elementos = d3.selectAll("[data-step]");
      if (elementos.size() > 0) {
        scrollerDown = scrollama();
        scrollerDown
          .setup({
            step: "[data-step]",
            offset: 0.8,
            debug: false,
          })
          .onStepEnter(actualizarMapaDown);

        scrollerUp = scrollama();
        scrollerUp
          .setup({
            step: "[data-step]",
            offset: 0.2,
            debug: false,
          })
          .onStepEnter(actualizarMapaUp);
      }
    }

    function actualizarMapaDown(response) {
      let el = d3.select(response.element);
      let direccion = response.direction;
      let paso = el.attr("data-step") || false;
      if (direccion == "down") {
        switch (paso) {
          case "area":
            muestraArea();
            console.log("down: area");
            break;
          case "sinaloa":
            detenIncendios();
            muestraSinaloa();
            console.log("down: sinaloa");
            break;
          default:
            break;
        }
      }
    }

    function actualizarMapaUp(response) {
      let el = d3.select(response.element);
      let direccion = response.direction;
      let paso = el.attr("data-step") || false;
      if (direccion == "up") {
        detenIncendios();
        switch (paso) {
          case "sinaloa":
            muestraArea();
            console.log("up: sinaloa");
            break;
          case "area":
            detenIncendios();
            muestraEstados();
            console.log("up: area");
            break;
          default:
            break;
        }
      }
    }

    function muestraEstados() {
      gMunicipios.transition().duration(duracion).style("opacity", 0);
      gEstados.transition().duration(duracion).style("opacity", 0.2);
      mapa.flyTo(coordenadas.estados.centro, coordenadas.estados.zoom, {
        duration: duracion / 1000,
      });
      muestraIncendios([]);
    }

    function muestraArea() {
      gMunicipios.transition().duration(duracion).style("opacity", 0.3);
      gEstados.transition().duration(duracion).style("opacity", 0.2);
      mapa.flyToBounds(cajaMunicipios, {
        animate: true,
        duration: duracion / 1000,
      });
      _.delay(animaIncendios, duracion);
    }

    function muestraSinaloa() {
      let arreglo = _.filter(data, function (o) {
        return o.anio == 2025 && o.estado == "Sinaloa";
      });
      gMunicipios.transition().duration(duracion).style("opacity", 0.3);
      gEstados.transition().duration(duracion).style("opacity", 0.2);
      mapa.flyToBounds(cajaSinaloa, {
        animate: true,
        duration: duracion / 1000,
      });
      muestraIncendios(arreglo);
    }

    function muestraTotal2025() {
      let arreglo = _.filter(data, function (o) {
        return o.anio == 2025;
      });
      gMunicipios.transition().duration(duracion).style("opacity", 0.3);
      gEstados.transition().duration(duracion).style("opacity", 0.2);
      mapa.flyTo(coordenadas.municipios.centro, coordenadas.municipios.zoom, {
        duration: duracion / 1000,
      });
      muestraIncendios(arreglo);
    }

    function calculaCentro(par) {
      let point = mapa.latLngToLayerPoint(new L.LatLng(par[1], par[0]));
      return point;
    }

    function muestraIncendios(data) {
      gIncendios
        .selectAll("circle")
        .data(data, (d) => d.id)
        .join(
          (enter) =>
            enter
              .append("circle")
              .attr("transform", getPunto)
              .attr("r", 0)
              .attr("x", 0)
              .attr("y", 0)
              .style("fill", "#ff993aff") //FD9A01
              .style("stroke", "rgba(185, 100, 20, 1)")
              .style("stroke-width", "0.5px")
              .style("opacity", 0.7)
              .transition()
              .duration(duracion)
              .attr("r", getRadio),
          (update) =>
            update.transition().duration(duracion).attr("r", getRadio),
          (exit) => exit.transition().duration(duracion).attr("r", 0).remove()
        );
    }

    function getPunto(d) {
      return "translate(" + d.punto.x + "," + d.punto.y + ")";
    }

    function getRadio(d) {
      let r = escalaRadio(d.superficie);
      return r < 0.1 ? 0.1 : r;
    }

    function animaIncendios() {
      if (flagAnimar) {
        flagAnimar = false;
        let dataOrdenada = _.values(
          _.groupBy(data, function (d) {
            return `${d.anio}-${d.fecha.getMonth()}`;
          })
        );
        dataOrdenada = _.sortBy(dataOrdenada, function (a) {
          return a[0].fecha;
        });
        let arreglo = [];
        let plano = [];
        gIncendios.selectAll("circle").data([]).exit().remove();
        let formatoFecha = d3.timeFormat("%B de %Y");
        let formatoSuperficie = d3.format(",.0f");
        let formatoNumero = d3.format(",.0f");
        intervalId = setInterval(function () {
          if (dataOrdenada.length > 0) {
            arreglo.push(dataOrdenada.shift());
            plano = _.flatten(arreglo);
            muestraIncendios(plano);

            let ultima = arreglo[arreglo.length - 1];
            fecha.html(formatoFecha(ultima[0].fecha));
            numero.html(formatoNumero(plano.length));
            let suma = 0;
            _.each(plano, function (o) {
              suma += o.superficie;
            });
            superficie.html(`${formatoSuperficie(suma)} hectáreas`);
          } else {
            detenIncendios();
          }
        }, duracion * 0.7);
      }
    }

    function detenIncendios() {
      flagAnimar = true;
      if (!_.isNull(intervalId)) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }
    setup();
  };
}
